import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ILocateUserReqBody, ILocateUserEntity } from '../../../entity';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';

export interface ILocateUserUseCase {
    execute(reqBody: ILocateUserReqBody): Promise<ILocateUserEntity>;
}

export class LocateUserUseCase implements ILocateUserUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(reqBody: ILocateUserReqBody): Promise<ILocateUserEntity> {
        return await this.userRepo.locateUser(reqBody);
    }
}
